import type { FC, SVGProps } from "react"
import {
	IconCheckOutline18 as CheckIcon,
	IconClockOutline18 as Clock,
	IconChatBubbleOutline18 as MessageSquare,
} from "nucleo-ui-outline-18"

import type { PriorityHeadlineType } from "./inbox"
import { LowPriority } from "../icons/priority/low-priority"
import { MediumPriority } from "../icons/priority/medium-priority"
import { NoPriority } from "../icons/priority/no-priority"
import { UrgentPriority } from "../icons/priority/urgent-priority"
import { SnoozeIcon } from "../icons/snooze-icon"

const ClosedIcon = () => (
	<div className="flex h-4 w-4 items-center justify-center rounded-full border border-white bg-green-500 text-white dark:border-gray-900 dark:bg-green-800">
		<CheckIcon className="h-4 w-4" />
	</div>
)

const UnsnoozedIcon = () => <SnoozeIcon className="h-4 w-4" />
const NewIcon = () => <MessageSquare className="h-4 w-4" />

export const PriorityIcons: Record<
	PriorityHeadlineType,
	typeof UrgentPriority | LucideIcon | FC
> = {
	HIGH: UrgentPriority,
	MEDIUM: MediumPriority,
	LOW: LowPriority,
	UNKNOWN: NoPriority,
	UNSNOOZED: UnsnoozedIcon,
	CLOSED: ClosedIcon,
	NEW: NewIcon,
	NEEDS_RESPONSE: Clock,
	WAITING_CUSTOMER: Clock,
} as const

type LucideIcon = FC<SVGProps<SVGSVGElement>>
